<template>
  <div>
    <v-card-title class="text--center"> </v-card-title>

    <v-card>
      <v-card-title>
        Gestion d'utilisateur
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :items-per-page="10"
        :headers="headers"
        :items="users"
        :search="search"
        no-results-text="The stuff you're looking for doesn't exist"
        no-data-text="Vous n'avez encore aucune commande"
        class="elevation-1"
      >
        <!-- CRUD BUTTON  and DIALOG -->

        <!-- CRUD ENDS HERE -->
        <!-- templating for dialog -->

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="new_item_dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >Créer un utilisateur</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Création d'utilisateur</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-card class="mt-3" width="550px" flat>
                      <v-form
                        class="input--fields__wrapper"
                        ref="createRef"
                        lazy-validation
                        v-on:submit.prevent="save"
                      >
                        <div class="input--fields__container">
                          <v-text-field
                            outlined
                            v-model="createName"
                            label="Nom"
                            :rules="[rules.required]"
                            prepend-icon="mdi-account"
                            required
                          ></v-text-field>
                          <v-text-field
                            outlined
                            :rules="[rules.required]"
                            v-model="createSecond"
                            label="Prenom"
                            prepend-icon="mdi-account"
                            required
                          ></v-text-field>
                        </div>
                        <v-text-field
                          outlined
                          v-model="createEmail"
                          :rules="[rules.required, rules.emailRules]"
                          label="Email"
                          prepend-icon="mdi-email"
                          required
                        ></v-text-field>
                        <div class="input--fields__container">
                          <v-text-field
                            outlined
                            :rules="[rules.required]"
                            v-model="createPassword"
                            label="Nouveau mot de passe"
                            type="password"
                            prepend-icon="mdi-lock"
                            required
                          ></v-text-field>
                          <v-text-field
                            type="password"
                            :rules="[
                              rules.required,
                              rules.min,
                              passwordConfirmationRule,
                            ]"
                            outlined
                            v-model="createPasswordConfirm"
                            label="Réessayer mot de passe"
                            prepend-icon="mdi-lock"
                            required
                          ></v-text-field>
                        </div>
                        <div class="input--fields__container">
                          <v-select
                            :rules="[rules.required]"
                            :items="roleSelect"
                            outlined
                            v-model="roleSelectValue"
                            maxLength="10"
                            label="Role"
                            prepend-icon="mdi-shield-account"
                            required
                          ></v-select>
                          <v-select
                            :rules="[rules.required]"
                            multiple
                            outlined
                            :items="subrolesSelect"
                            v-model="subrolesSelectValue"
                            maxLength="10"
                            label="Sous role"
                            prepend-icon="mdi-file-document"
                            required
                          >
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index === 0">
                                <span>{{ item }}</span>
                              </v-chip>
                              <span
                                v-if="index === 1"
                                class="grey--text caption"
                                >(+{{
                                  subrolesSelectValue.length - 1
                                }}
                                autres)</span
                              >
                            </template>
                          </v-select>
                        </div>
                      </v-form>
                    </v-card>
                    <!-- NEW USER EEEEEEEEEENDS HERE -->
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="new_item_dialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    :loading="userloading"
                    text
                    @click="createUser"
                    >Enregistrer</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <template>
            <v-row justify="center">
              <v-dialog v-model="subroles_dialog" max-width="290">
                <v-card class="mt-3" width="500px" flat>
                  <v-container
                    id="scroll-target"
                    style="max-height: 400px"
                    class="overflow-y-auto"
                  >
                    <v-row
                      v-scroll:#scroll-target="onScroll"
                      align="center"
                      justify="center"
                    >
                    </v-row>

                    <v-chip
                      class="mt-6 mx-4"
                      v-for="(role, index) in editedItem.subroles"
                      :key="index + person"
                    >
                      <v-avatar left>
                        <v-icon>mdi-account</v-icon>
                      </v-avatar>

                      {{ role }}
                    </v-chip>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- Password -->

          <template>
            <v-row justify="center">
              <v-dialog v-model="password_dialog" max-width="350">
                <v-card>
                  <v-card-title>
                    <span class="subtitle">Modification mot de passe</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-card class="mt-3" max-width="500px" flat>
                        <v-form
                          class="input--fields__wrapper"
                          ref="passwordRef"
                          lazy-validation
                          v-on:submit.prevent="editPassword"
                        >
                          <v-text-field
                            outlined
                            v-model="updatePassword"
                            label="Nouveau Mot de passe"
                            type="password"
                            :rules="[rules.required, rules.min]"
                            prepend-icon="mdi-lock"
                            required
                          ></v-text-field>
                          <v-text-field
                            type="password"
                            outlined
                            :rules="[
                              rules.required,
                              rules.min,
                              passwordConfirmationRuleUpdate,
                            ]"
                            v-model="updatePasswordAgain"
                            label="Réessayer mot de passe"
                            prepend-icon="mdi-lock"
                            required
                          ></v-text-field>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="password_dialog = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              color="blue darken-1"
                              :loading="updateloading"
                              text
                              @click="editPassword"
                              >Enregistrer</v-btn
                            >
                          </v-card-actions>
                        </v-form>
                      </v-card>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <template>
            <v-row justify="center">
              <v-dialog v-model="subroles_update" max-width="290">
                <v-card width="400px">
                  <v-card-title>
                    <span class="headline">Modifier sous role</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form
                        class="input--fields__wrapper"
                        ref="form_card"
                        lazy-validation
                        v-on:submit.prevent="save"
                      >
                        <v-select
                          :rules="[rules.required]"
                          multiple
                          outlined
                          :items="subrolesSelect"
                          v-model="itemSubroles"
                          maxLength="10"
                          label="Sous role"
                          prepend-icon="mdi-file-document"
                          required
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption"
                              >(+{{ itemSubroles.length - 1 }} autres)</span
                            >
                          </template>
                        </v-select>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="subroles_update = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            :loading="subroles_update_loading"
                            text
                            @click="EditsubrolesItem"
                            >Enregistrer</v-btn
                          >
                        </v-card-actions>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
          </template>

          <!-- -->
        </template>

        <!-- Second DIALOG -->

        <!-- ENDS HERE -->
        <template v-slot:item.subroles="{ item }">
          <v-icon medium class="ml-3" v-on:click="subrolesExhibition(item)">
            mdi-file-chart
          </v-icon>
        </template>
        <template v-slot:item.Password="{ item }">
          <v-icon medium class="ml-10" @click="editPasswordDialog(item)">
            mdi-lock
          </v-icon>
        </template>
        <template v-slot:item.subrolesediting="{ item }">
          <v-icon medium class="ml-8" @click="EditsubrolesItemDialog(item)">
            mdi-update
          </v-icon>
        </template>
        <template v-slot:item.delete="{ item }">
          <v-icon medium class="ml-5" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!--   -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: `Drawer`,
  components: {},
  mounted() {
    this.isMounted();

    this.checkRendering();
  },
  methods: {
    isMounted() {
      this.$store.dispatch("admin/getallusers", this.User).then((resp) => {
        this.users = resp.data.users;
        this.users.forEach((user) => {
          if (user.role === "pawn") {
            user.role = "Utilisateur";
          } else if (user.role === "dg") {
            user.role = "Directeur général";
          } else if (user.role === "entity") {
            user.role = "Entité";
          } else if (user.role === "admin") {
            user.role = "Administrateur";
          }
        });
      });
    },
    checkRendering() {
      this.$store.state.sdrawer.toRender = true;
    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    isClicked() {
      this.$store.dispatch("new/IsOpened ", {
        userName: this.User.name,
        requestId: this.editedItem.requestId,
      });
    },
    save() {
      this.$store
        .dispatch("new/NewDocumentEditing", {
          userName: this.User.name,
          requestId: this.editedItem.requestId,
          externalId: this.editedItem.externalId,
          marketNumber: this.editedItem.marketNumber,
          callofferNumber: this.editedItem.callofferNumber,
        })
        .then((resp) => {
          if (this.editedIndex > -1) {
            Object.assign(this.users[this.editedIndex], this.editedItem);
          } else {
            this.users.push(this.editedItem);
          }
          this.close();
        });
    },
    SearchByNumber() {
      this.rloading = true;

      this.$store
        .dispatch("new/Affecting_NewDocument", {
          userName: this.User.name,
          User: this.User,
          requestId: this.searchnumber,
        })
        .then((resp) => {
          this.rloading = false;

          this.search_items = resp.data.users;
          this.searchnumber = resp.data.requestId;
          this.dialogSearch = true;
        })
        .catch(() => {
          this.rloading = false;
        });
    },
    editPasswordDialog(item) {
      this.itemEmail = item.email;

      this.password_dialog = true;
      editPassword();
    },
    editPassword() {
      if (this.$refs.passwordRef.validate()) {
        this.$store
          .dispatch("admin/updatePassword", {
            role: this.User.role,
            email: this.itemEmail,
            password: this.updatePassword,
            passwordConfirm: this.updatePasswordAgain,
          })
          .then((resp) => {
            this.password_dialog = false;
            this.updateloading = false;
            this.reset();
          });
      }
    },
    EditsubrolesItemDialog(item) {
      this.itemEmail = item.email;
      this.itemSubroles = item.subroles;

      this.subroles_update = true;
      EditsubrolesItem();
    },
    EditsubrolesItem() {
      this.$store
        .dispatch("admin/updateusersubroles", {
          role: this.User.role,
          email: this.itemEmail,
          subroles: this.itemSubroles,
        })
        .then((resp) => {
          this.subroles_update = false;
          this.subroles_update_loading = false;
          this.$store.dispatch("admin/getallusers", this.User).then((resp) => {
            this.users = resp.data.users;
          });
        });
    },
    subrolesExhibition(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.subroles_dialog = true;
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    // Create User
    createUser() {
      if (this.$refs.createRef.validate()) {
        if (this.roleSelectValue === "Utilisateur") {
          this.roleSelectValue = "pawn";
        } else if (this.roleSelectValue === "Directeur général") {
          this.roleSelectValue = "dg";
        } else if (this.roleSelectValue === "Assistant directeur général") {
          this.roleSelectValue = "assistantDg";
        } else if (this.roleSelectValue === "Entité") {
          this.roleSelectValue = "entity";
        } else if (this.roleSelectValue === "Administrateur") {
          this.roleSelectValue = "admin";
        }
        this.userloading = true;

        this.$store
          .dispatch("admin/createuser", {
            role: this.User.role,
            name: `${this.createName} ${this.createSecond}`,
            email: this.createEmail,
            password: this.createPassword,
            passwordConfirm: this.createPasswordConfirm,
            createRole: this.roleSelectValue,
            subroles: this.subrolesSelectValue,
          })
          .then((resp) => {
            this.new_item_dialog = false;
            this.userloading = false;
            this.isMounted();
          });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store
          .dispatch("admin/deleteuser", { User: this.User, email: item.email })
          .then((resp) => {
            const index = this.users.indexOf(item);
            this.users.splice(index, 1);
          });
    },
    url(name) {
      window.open(`${name}`);
    },
    reset() {
      this.$refs.passwordRef.reset();
    },
  },
  computed: {
    _headers() {
      return this.User.role === "pawn"
        ? this.headers.filter((x) => x.show)
        : this.headers;
    },
    User() {
      return this.$store.state.loginstore.user;
    },
    error() {
      return this.$store.state.new.error;
    },
    error_is_true() {
      return this.$store.state.new.error_is_true;
    },
    formTitle() {
      return "Consulter l'affectation";
    },
    passwordConfirmationRuleUpdate() {
      return () =>
        this.updatePassword === this.updatePasswordAgain ||
        "Les mots de passe saisis ne sont pas identiques";
    },
    passwordConfirmationRule() {
      return () =>
        this.createPassword === this.createPasswordConfirm ||
        "Les mots de passe saisis ne sont pas identiques";
    },
  },
  data: () => ({
    // Rules
    rules: {
      required: (value) => !!value || "Ce champ est obligatoire.",
      min: (v) =>
        v.length >= 8 || "Le champ doit contenir 8 caractères minimum",
      emailRules: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Veuillez entrer une adresse électronique valide",
    },

    // Password Update
    updatePassword: "",
    updatePasswordAgain: "",
    updateloading: false,
    itemEmail: "",
    // subrolesupdate

    itemSubroles: [],
    subroles_update_loading: false,

    // // --------------
    // dialogs
    new_item_dialog: false,
    subroles_dialog: false,
    password_dialog: false,
    subroles_update: "",
    //
    // New Item dialog

    // CREATE USER DATA
    userloading: false,

    createName: "",
    createSecond: "",
    createEmail: "",
    createPassword: "",
    createPasswordConfirm: "",
    subrolesSelect: [
      "Assurances",
      "Attachement",
      "Caution bancaire",
      "Caution définitive",
      "Contrats",
      "Convention",
      "Convocation Tribunal",
      "Courrier",
      "Déclaraction Assurances RH",
      "Déclaraction RCAR",
      "Expédition",
      "Facture",
      "Marchés",
      "Minute",
      "Ordre de service (OS)",
      "Plan Architecte",
      "Plans BCT",
      "Plans BET",
      "Rapport Laboratoire",
      "Rapport de mission BET",
      "Rapports d'achévement",
      "Relevés Bancaire",
      "Réclamations",
      "Réponses consultation",
    ],
    subrolesSelectValue: [],
    roleSelect: [
      "Utilisateur",
      "Directeur général",
      "Assistant directeur général",
      "Entité",
      "Administrateur",
      "bov",
    ],
    roleSelectValue: "",

    //
    // Affectation du documents
    dialogload: false,
    search_items: [],
    searchnumber: null,
    dialogSearch: false,
    rloading: false,
    picked_item: "",
    //
    offsetTop: 0,
    dialog: false,
    dialogS: false,
    editedIndex: -1,
    editedItem: {
      email: "",
      name: "",
      role: "",
      subroles: "",
    },
    defaultItem: {
      name: "",
      email: "",
      role: "",
      subroles: "",
    },
    headers: [
      { text: "Nom", value: "name", show: true },
      { text: "Adresse mail", value: "email", show: true },
      { text: "Role", value: "role", show: true },
      { text: "Sous-role", value: "subroles", show: true },
      { text: "Modifier mot de passe", value: "Password", show: true },
      { text: "Modifier sous role", value: "subrolesediting", show: true },
      { text: "Supprimer", value: "delete", show: true },
    ],
    users: [],
    search: "",
  }),
};
</script>
<style scoped>
.input--fields_is {
  display: grid;
  max-width: 370px;
  margin-left: 31px;
}

.alert {
  margin-left: 31px;
  max-width: 370px;
}

.page__event--container {
  max-width: 1148px;
  width: 100%;
  margin: 0 auto;
}

.input--fields__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.v-card {
  border-radius: 8px;
}

@media only screen and (max-width: 375px) {
  .page__event--container {
    margin: 0 auto;
  }

  .input--fields__submit_ren {
    margin-left: 5px !important;
    padding: 0 !important;
  }
  .input--fields__submit_ja {
    margin-left: 5px !important;
  }
  .card_x {
    margin-top: 12px;
    width: 600px;
  }
  .col_card {
    margin-right: 40px;
  }
}

.v-text-field__slot input {
  text-align: left;
}
</style>
